import React from 'react';
import Navbar from './Navbar';
import Icon from '../assets/Icon1.png';
import ContactUpdated from './ContactUpdated';
import Footer from './Footer';

const ServicesUpdated = () => {
  return (
    <div>
        <div className='px-20 py-4 bg-[#8AD7BD]/60 flex flex-col'>
            <div className='flex '>
                <div className='basis-[60%]'>
                    <Navbar />
                    <div className='pl-4 mt-24 mb-32 flex flex-col gap-4'>
                        <span className='text-7xl font-medium tracking-wide leading-tight opacity-90'>Our Services </span>
                        <span className='text-lg font-normal tracking-wider opacity-80'>Where your brand's full potential becomes its reality. Let's embark on this journey of growth together.Let's embark on this journey of growth together.</span>
                    </div>
                </div>
            </div>
        </div>
        <div className='flex flex-col gap-8 -mt-20 overflow-y-auto h-[45rem] py-3'>
            <div className='flex gap-8 justify-center items-center'>
                <div className='flex px-4 py-8 flex-col gap-3 bg-white shadow-lg'>
                    <span className='w-12 h-12'><img src={Icon} alt='' className='w-full h-full'></img></span>
                    <span className='uppercase font-normal opacity-80 text-lg'>Logo & brand identity</span>
                    <span className='opacity-80 font-normal  text-base w-80'>Make your business identity as unique as possible</span>
                </div>
                <div className='flex px-4 py-8 flex-col gap-3 bg-white shadow-lg'>
                    <span className='w-12 h-12'><img src={Icon} alt='' className='w-full h-full'></img></span>
                    <span className='uppercase font-normal opacity-80 text-lg'>Campaign Management</span>
                    <span className='opacity-80 font-normal  text-base w-80'>Make your business identity as unique as possible</span>
                </div>
                <div className='flex px-4 py-8 flex-col gap-3 bg-white shadow-lg'>
                    <span className='w-12 h-12'><img src={Icon} alt='' className='w-full h-full'></img></span>
                    <span className='uppercase font-normal opacity-80 text-lg'>Traditional media + advertising</span>
                    <span className='opacity-80 font-normal  text-base w-80'>Make your business identity as unique as possible</span>
                </div>
            </div>
            <div className='flex gap-8 justify-center items-center'>
                <div className='flex px-4 py-8 flex-col gap-3 bg-white shadow-lg'>
                    <span className='w-12 h-12'><img src={Icon} alt='' className='w-full h-full'></img></span>
                    <span className='uppercase font-semibold text-lg'>Corporate Communication</span>
                    <span className='opacity-80 font-semibold text-base w-80'>Make your business identity as unique as possible</span>
                </div>
                <div className='flex px-4 py-8 flex-col gap-3 bg-white shadow-lg'>
                    <span className='w-12 h-12'><img src={Icon} alt='' className='w-full h-full'></img></span>
                    <span className='uppercase font-semibold text-lg'>Digital & Media Strategy</span>
                    <span className='opacity-80 font-semibold text-base w-80'>Make your business identity as unique as possible</span>
                </div>
                <div className='flex px-4 py-8 flex-col gap-3 bg-white shadow-lg'>
                    <span className='w-12 h-12'><img src={Icon} alt='' className='w-full h-full'></img></span>
                    <span className='uppercase font-semibold text-lg'>Lead & Client Generation</span>
                    <span className='opacity-80 font-semibold text-base w-80'>Make your business identity as unique as possible</span>
                </div>
            </div>
            <div className='flex gap-8 justify-center items-center'>
                <div className='flex px-4 py-8 flex-col gap-3 bg-white shadow-lg'>
                    <span className='w-12 h-12'><img src={Icon} alt='' className='w-full h-full'></img></span>
                    <span className='uppercase font-semibold text-lg'>Corporate Communication</span>
                    <span className='opacity-80 font-semibold text-base w-80'>Make your business identity as unique as possible</span>
                </div>
                <div className='flex px-4 py-8 flex-col gap-3 bg-white shadow-lg'>
                    <span className='w-12 h-12'><img src={Icon} alt='' className='w-full h-full'></img></span>
                    <span className='uppercase font-semibold text-lg'>Digital & Media Strategy</span>
                    <span className='opacity-80 font-semibold text-base w-80'>Make your business identity as unique as possible</span>
                </div>
                <div className='flex px-4 py-8 flex-col gap-3 bg-white shadow-lg'>
                    <span className='w-12 h-12'><img src={Icon} alt='' className='w-full h-full'></img></span>
                    <span className='uppercase font-semibold text-lg'>Lead & Client Generation</span>
                    <span className='opacity-80 font-semibold text-base w-80'>Make your business identity as unique as possible</span>
                </div>
            </div>
            <div className='flex gap-8 justify-center items-center'>
                <div className='flex px-4 py-8 flex-col gap-3 bg-white shadow-lg'>
                    <span className='w-12 h-12'><img src={Icon} alt='' className='w-full h-full'></img></span>
                    <span className='uppercase font-semibold text-lg'>Logo & brand identity</span>
                    <span className='opacity-80 font-semibold text-base w-80'>Make your business identity as unique as possible</span>
                </div>
                <div className='flex px-4 py-8 flex-col gap-3 bg-white shadow-lg'>
                    <span className='w-12 h-12'><img src={Icon} alt='' className='w-full h-full'></img></span>
                    <span className='uppercase font-semibold text-lg'>Campaign Management</span>
                    <span className='opacity-80 font-semibold text-base w-80'>Make your business identity as unique as possible</span>
                </div>
                <div className='flex px-4 py-8 flex-col gap-3 bg-white shadow-lg'>
                    <span className='w-12 h-12'><img src={Icon} alt='' className='w-full h-full'></img></span>
                    <span className='uppercase font-semibold text-lg'>Traditional media + advertising</span>
                    <span className='opacity-80 font-semibold text-base w-80'>Make your business identity as unique as possible</span>
                </div>
            </div>
            <div className='flex gap-8 justify-center items-center'>
                <div className='flex px-4 py-8 flex-col gap-3 bg-white shadow-lg'>
                    <span className='w-12 h-12'><img src={Icon} alt='' className='w-full h-full'></img></span>
                    <span className='uppercase font-semibold text-lg'>Corporate Communication</span>
                    <span className='opacity-80 font-semibold text-base w-80'>Make your business identity as unique as possible</span>
                </div>
                <div className='flex px-4 py-8 flex-col gap-3 bg-white shadow-lg'>
                    <span className='w-12 h-12'><img src={Icon} alt='' className='w-full h-full'></img></span>
                    <span className='uppercase font-semibold text-lg'>Digital & Media Strategy</span>
                    <span className='opacity-80 font-semibold text-base w-80'>Make your business identity as unique as possible</span>
                </div>
                <div className='flex px-4 py-8 flex-col gap-3 bg-white shadow-lg'>
                    <span className='w-12 h-12'><img src={Icon} alt='' className='w-full h-full'></img></span>
                    <span className='uppercase font-semibold text-lg'>Lead & Client Generation</span>
                    <span className='opacity-80 font-semibold text-base w-80'>Make your business identity as unique as possible</span>
                </div>
            </div>
            <div className='flex gap-8 justify-center items-center'>
                <div className='flex px-4 py-8 flex-col gap-3 bg-white shadow-lg'>
                    <span className='w-12 h-12'><img src={Icon} alt='' className='w-full h-full'></img></span>
                    <span className='uppercase font-semibold text-lg'>Corporate Communication</span>
                    <span className='opacity-80 font-semibold text-base w-80'>Make your business identity as unique as possible</span>
                </div>
                <div className='flex px-4 py-8 flex-col gap-3 bg-white shadow-lg'>
                    <span className='w-12 h-12'><img src={Icon} alt='' className='w-full h-full'></img></span>
                    <span className='uppercase font-semibold text-lg'>Digital & Media Strategy</span>
                    <span className='opacity-80 font-semibold text-base w-80'>Make your business identity as unique as possible</span>
                </div>
                <div className='flex px-4 py-8 flex-col gap-3 bg-white shadow-lg'>
                    <span className='w-12 h-12'><img src={Icon} alt='' className='w-full h-full'></img></span>
                    <span className='uppercase font-semibold text-lg'>Lead & Client Generation</span>
                    <span className='opacity-80 font-semibold text-base w-80'>Make your business identity as unique as possible</span>
                </div>
            </div>
        </div>
        <ContactUpdated />
        <Footer />
    </div>
  )
}

export default ServicesUpdated;